module.exports = __webpack_public_path__ + "static/media/search.5dea919b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/search.svg
// module id = 968
// module chunks = 0